import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';
import { FloatingBannerWrapper } from '@/components/shared/components/common.StyledComponents';
import { Z_INDEX } from '@/components/shared/constants/zIndex';

export const BannerWrapper = styled(FloatingBannerWrapper)`
    top: ${rem(16)};
    z-index: ${Z_INDEX.OUT_OF_SYNC_BANNER};
    background-color: #fff8e1;
    border: 1px solid #f59e0b;
`;
